export function useScrollSpy(sectionIds, options = {}) {
    const activeId = ref(null)
    let observer

    const createObserver = () => {
        observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        activeId.value = entry.target.id
                    }
                })
            },
            {
                rootMargin: options.rootMargin ?? '-150px 0px -60% 0px',
                threshold: options.threshold ?? 0
            }
        )
    }

    const observeSections = (ids) => {
        if (!observer) return

        ids.forEach((id) => {
            const el = document.getElementById(id)
            if (el) observer.observe(el)
        })
    }

    const unobserveAll = () => {
        observer?.disconnect()
        observer = null
    }

    onMounted(() => {
        createObserver()
        observeSections(unref(sectionIds))
    })

    watch(
        () => unref(sectionIds),
        (ids) => {
            unobserveAll()
            createObserver()
            observeSections(ids)
        },
        { immediate: false }
    )

    onBeforeUnmount(() => {
        unobserveAll()
    })

    return { activeId }
}
